import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Marcela G.',
  province: 'Córdoba',
  stars: 5,
  text: 'Llevaba años sintiendo que algo dentro mío estaba desconectado. Que el cansancio no era físico. Que los dolores tenían algo que ver con todo lo que guardaba. El Tomo 3 me hizo llorar tres veces. Porque cada página hablaba exactamente de mí.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  province: 'Rosario',
  stars: 5,
  text: 'Probé mil cosas. Yoga, meditación, terapia. Todo por separado. El MegaPack Código Fértil fue la primera vez que todo se conectó en un sistema que tiene sentido. Lo leo cada luna nueva.'
}, {
  initials: 'RM',
  name: 'Romina M.',
  province: 'Buenos Aires',
  stars: 5,
  text: 'El Bono de Diario Emocional cambió mis mañanas para siempre. Son 5 minutos pero cambian todo el día. Es la primera vez en años que siento que me escucho de verdad.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-284">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-brand-accent text-sm" data-id="element-285">
          ⭐
        </span>)}
    </div>;
}
function TestimonialCard({
  initials,
  name,
  province,
  stars,
  text,
  index
}: {
  initials: string;
  name: string;
  province: string;
  stars: number;
  text: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-brand-card border border-brand-border-soft rounded-xl p-5 sm:p-6 flex flex-col gap-3 transition-all duration-500 hover:border-brand-accent hover:shadow-medium shadow-soft ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-286">
      <div className="flex items-center justify-between mb-1" data-id="element-287">
        <div className="flex items-center gap-2" data-id="element-288">
          <div className="w-8 h-8 rounded-full bg-brand-alternate border border-brand-border-soft flex items-center justify-center flex-shrink-0" data-id="element-289">
            <span className="text-brand-heading font-bold text-xs" data-id="element-290">
              {initials}
            </span>
          </div>
          <StarRating count={stars} data-id="element-291" />
        </div>
      </div>
      <p className="text-brand-body font-display text-base sm:text-lg leading-relaxed flex-grow italic" data-id="element-292">
        "{text}"
      </p>
      <div className="pt-3 border-t border-brand-border-soft" data-id="element-293">
        <p className="text-brand-heading text-sm font-semibold" data-id="element-294">
          {name} — {province}
        </p>
      </div>
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-brand-alternate py-6 md:py-8 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-295">
      <div className="container mx-auto max-w-5xl" data-id="element-296">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-297">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-298" />)}
        </div>
      </div>
    </section>;
}